module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', {
    staticClass: "text-xs-left",
    class: {
      'fixedPlayer': _vm.scrolltop > 100
    }
  }, [_c('v-col', {
    attrs: {
      "xs12": "",
      "md6": "",
      "offset-md3": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "xs10": "",
      "offset-xs2": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "error": "",
      "dismissible": ""
    },
    model: {
      value: (_vm.alert),
      callback: function($$v) {
        _vm.alert = $$v
      },
      expression: "alert"
    }
  }, [_vm._v("\n            請選擇音檔！\n          ")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('br'), _vm._v(" "), (_vm.audio.autoplay === 'enable') ? _c('span', {
    on: {
      "click": function($event) {
        _vm.toggleAudio()
      }
    }
  }, [(_vm.audio.state === 'pause') ? _c('img', {
    attrs: {
      "src": require("../assets/images/btn_play.svg")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.audio.state === 'play') ? _c('img', {
    attrs: {
      "src": require("../assets/images/btn_pause.svg")
    }
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-left",
    attrs: {
      "xs10": ""
    }
  }, [_vm._v("\n          目前播放音檔：" + _vm._s(_vm.audio.title) + " "), _c('br'), _vm._v(" "), (_vm.audio.autoplay === 'enable') ? [_c('audio', {
    ref: "audio",
    attrs: {
      "src": _vm.audio.url
    }
  }), _vm._v(" "), _c('v-progress-linear', {
    attrs: {
      "value": _vm.audio.currentPos,
      "height": "20",
      "fill": "#6c729d"
    }
  })] : [_c('audio', {
    ref: "audio",
    staticStyle: {
      "display": "block",
      "width": "100%"
    },
    attrs: {
      "src": _vm.audio.url,
      "controls": true
    }
  })]], 2)], 1), _vm._v(" "), (_vm.audio.autoplay === 'enable') ? _c('v-row', [_c('v-col', {
    staticClass: "text-xs-right",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n          " + _vm._s(_vm.duration(_vm.audio.currentTime)) + " / " + _vm._s(_vm.duration(_vm.audio.duration)) + "\n        ")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.areas), function(area, key, index) {
    return _c('v-row', {
      key: index,
      staticClass: "text-xs-left"
    }, [_c('v-col', {
      attrs: {
        "sm10": "",
        "offset-sm2": "",
        "md5": "",
        "offset-md4": ""
      }
    }, [_c('div', {
      staticClass: "big-title",
      class: {
        'color-1': (index + 1) === 1, 'color-2': (index + 1) === 2, 'color-3': (index + 1) === 3
      }
    }, [_vm._v("\n        " + _vm._s(key) + "\n        "), _c('span', {
      on: {
        "click": function($event) {
          _vm.toggle(index + 1)
        }
      }
    }, [(!_vm.section['s' + (index + 1)]) ? _c('img', {
      attrs: {
        "src": require("../assets/images/btn_down_arrow.svg")
      }
    }) : _vm._e(), _vm._v(" "), (_vm.section['s' + (index + 1)]) ? _c('img', {
      attrs: {
        "src": require("../assets/images/btn_up_arrow.svg")
      }
    }) : _vm._e()])])]), _vm._v(" "), (_vm.section['s' + (index + 1)]) ? _c('v-col', {
      attrs: {
        "sm10": "",
        "offset-sm2": "",
        "md5": "",
        "offset-md4": ""
      }
    }, _vm._l((area), function(section, section_key, section_index) {
      return _c('div', [_c('div', {
        staticClass: "title",
        class: {
          'color-1': (index + 1) === 1, 'color-2': (index + 1) === 2, 'color-3': (index + 1) === 3
        }
      }, [_vm._v(_vm._s(section_key))]), _vm._v(" "), _vm._l((section), function(place, place_key, place_index) {
        return _c('div', {
          staticClass: "content",
          class: {
            'color-1': (index + 1) === 1, 'color-2': (index + 1) === 2, 'color-3': (index + 1) === 3
          }
        }, [_vm._v("\n           " + _vm._s(place_key) + "\n          "), _c('div', {
          staticClass: "track",
          class: {
            'track-color-1': (index + 1) === 1, 'track-color-2': (index + 1) === 2, 'track-color-3': (index + 1) === 3
          }
        }, _vm._l((place), function(track, track_key) {
          return _c('div', [_vm._v(" " + _vm._s(track_key) + " " + _vm._s(track) + "\n              "), _c('span', {
            on: {
              "click": function($event) {
                _vm.selectTrack(track, track_key)
              }
            }
          }, [_c('img', {
            attrs: {
              "src": require("../assets/images/btn_play_small.svg")
            }
          })]), _vm._v(" "), _c('span', [_c('a', {
            attrs: {
              "href": '/taichung/static/mp3/' + track + '.mp3',
              "download": ""
            }
          }, [_c('img', {
            attrs: {
              "src": require("../assets/images/btn_download.svg")
            }
          })])])])
        }))])
      })], 2)
    })) : _vm._e()], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c70f340"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BookAudio.vue
// module id = 628
// module chunks = 1